// import React, { useState } from 'react';

import './NavigationBar.scss';

const NavigationBar: React.FunctionComponent = () => {
  return (
    <>
      <div className="adminNavigationBar"></div>
    </>
  );
};

export { NavigationBar };
